import React, { useState } from "react";
import { Fragment } from "react";
import { Grid, Segment, Icon, Input, Menu } from "semantic-ui-react";
import { Helmet } from "react-helmet";
import VM from "./VM";
import "./vmList.css";
import { Button, Dropdown, Form, Image } from "semantic-ui-react";
import InfinitScroll from "react-infinite-scroll-component";
import NoImg from "../../../_assets/no-photo.png";
const statusOptions = [
  { key: "yes", text: "Yes", value: 1 },
  { key: "no", text: "No", value: 0 },
];

const baseS3Url = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";
const VendingMachines = ({
  loading,
  vmData,
  vmlistData,
  onSearchChnage,
  onIdSearchChange,
  saveVMDetailsData,
  OnClickVMSideDetailsPage,
  onchangeSearchName,
  vmname,
  vmSerialNo,
  onChangeOfName,
  onChangeOfSerialNo,
  vmTypeOptions,
  hardware_types,
  warehouses,
  oparationalstatusTypes,
  onChangeOfVMTypeId,
  onChangeOfHardWareTypeId,
  onChangeOfLat,
  onChangeOfLng,
  lat,
  lng,
  stateList,
  onChangeOfVMCity,
  onChangeOfVMState,
  onChangeOfVMStreet,
  vmStreet,
  onChangeOfSharePercentage,
  sharePercentage,
  onChangeOfIsConsumerAppEnabled,
  onChangeOWarehouse,
  onChangeOparetionalStatus,
  AddCohortsOptions,
  onChangeOfAddCohorts,
  added_cohort_id,
  removed_cohort_id,
  onChangeOfVMCohort,
  RemoveCohortsOptions,
  onChangeOfRemoveCohorts,
  RemovePaymentsOptions,
  AddPaymentsOptions,
  RemoveSlotsOption,
  handleUpdateVM,
  onChangeOfRemovePayments,
  onChangeOfAddPayments,
  onChangeOfIsHealthAppEnabled,
  onChangeOfRemoveSlots,
  handleCreateVm,
  onSearchInputChange,
  onChangeSelectFilterType,
  UploadImgBtn,
  UploadImgFun,
  fetchNextUsers,
  allMachine,
  morescroll,
  openmodel,
  Decomissionmodel,
  openDecomissionmodel,
  closeDecomissionmodel,
  closemodel,
  Search,
  DecomissionMachine,
  modal,
  cityList,
  cityLoading,
  location_types,
  onChangeOfLocationTypeId,
  onChangeCartLimit,
  cart_Limt,

  corporates,
  onChangeCorporates


  
  
}) => {
  const [inputFields, setInputFields] = useState([
    {
      slot_id: null,
      mv_id: null,
      capacity: null,
    },
  ]);
  const [view1, setView1] = useState(true);

  const [view2, setView2] = useState(false);
  const [view3, setView3] = useState(false);
  const [view4, setView4] = useState(false);
  const [width, setWidth] = useState("100%");
  /* const [modal, setModal] = useState(false); */
  const [upmodal, setupModal] = useState(false);
  const [vmid, setVmid] = useState("");
  const [dropdownState, setDropdownState] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [searchQuery, setsearchQuery] = useState([]);
  const [AddslotModel, setAddslotModel] = useState(false);

  const handleAddSlotModle = () => {
    setAddslotModel(!AddslotModel);
  };
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      slot_id: 0,
      mv_id: 0,
      capacity: 0,
    });
    setInputFields(values);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  const deleteMachine = () => {
    DecomissionMachine(vmid);
    closeDecomissionmodel();
  };
  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === "slot_id") {
      values[index].slot_id = event.target.value;
    } else if (event.target.name === "mv_id") {
      values[index].mv_id = event.target.value;
    } else if (event.target.name === "capacity") {
      values[index].capacity = event.target.value;
    }

    setInputFields(values);
    console.log(
      "setInputFields>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
      inputFields
    );
  };

  const handleSubmit = (e, inputFields) => {
    e.preventDefault();
    console.log("_______________________________________-", inputFields);
  };

  const handleUpdate = (e, inputFields) => {
    e.preventDefault;
    const nullInputfields = [];
    let yes = false;
    console.log("inputdata tah", inputFields[0].slot_id);
    if (!inputFields[0].slot_id) {
      if (!inputFields[0].mv_id) {
        if (!inputFields[0].capacity) {
          console.log("inputFeilds- tah---", inputFields[0].slot_id);
          yes = true;
        }
      }
    }
    const inputFieldsData = yes ? nullInputfields : inputFields;

    handleUpdateVM(vmid, inputFieldsData);
  };

  const handleSearchChange = (e, { searchQuery }) => {
    this.setState({ searchCohortQuery: searchQuery });
    /*  console.log("search", this.searchQuery); */
  };

  const vmDetails = (id) => {
    setWidth("100%");
    setVmid(id);
    console.log("idddd", id);
    OnClickVMSideDetailsPage(id);
  };
  const handleView4 = () => {
    setView4(!view4);
  };

  const handleView3 = () => {
    setView3(!view3);
  };

  /*   const openmodel = () => {
    console.log("Model Open");
    setModal(true);
  };
  const closemodel = () => {
    console.log("Model Open");
    setModal(false);
  }; */

  const openupdatemodal = () => {
    console.log("Model Open");
    setupModal(!upmodal);
    setModal(false);
  };
  const closeupdatemodal = () => {
    console.log("Model Open");
    setupModal(!upmodal);
    setModal(true);
  };
  const updatemodal = () => {
    console.log("Model Open");
    setupModal(!upmodal);
    setModal(false);
  };
  const handleView1 = () => {
    setView1(!view1);
  };

  const handleDropdownClick = () => {
    setDropdownState(!dropdownState);
  };
  const handleSetDropdownValue = (value) => {
    setDropdownValue(value);
    setDropdownState(!dropdownState);
  };

  const handleView2 = () => {
    setView2(!view2);
  };
  const vmdt = saveVMDetailsData;
  //console.log("vending machines-------", saveVMDetailsData);
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: "90vh" }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        /*  fontSize: "20px", */
        marginLeft: "15%",
        "margin-top": "3%",
      }}
    >
      {Decomissionmodel && (
        <div className="modal">
          <div className="modal-Decomission">
            <div style={{ "font-size": "20px", "text-align": "center" }}>
              <p style={{ margin: "0px" }}>Are you sure you want to</p>
              <p>Decomission the vending machine?</p>
            </div>
            <hr />

            <div
              style={{
                display: "flex",
                "justify-content": "space-around",
                "align-items": "center",
              }}
            >
              <div>
                <p
                  style={{ cursor: "pointer", margin: "0PX" }}
                  onClick={closeDecomissionmodel}
                >
                  NO
                </p>
              </div>
              <div class="vl"></div>
              <div>
                {" "}
                <p
                  style={{ margin: "0px", cursor: "pointer" }}
                  onClick={deleteMachine}
                >
                  YES
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {modal && (
        <div className="modal">
          <div className="modal-content" style={{ overflow: "auto" }}>
            <p style={{ cursor: "pointer" }} onClick={closemodel}>
              Close
            </p>
            <div
              style={{
                display: "grid",
                width: "50%",
                marginLeft: "25%",
                "margin-left": "25%",
                "margin-top": "0%",
              }}
            >
              <Grid.Row loading={loading} style={{ marginBottom: "0rem" }}>
                <Grid.Column width={8}>
                  <Form>
                    <Form.Field style={{ "margin-bottom": "2rem" }}>
                      <label>VM NAME</label>
                      <input
                        placeholder="Enter Machine Name"
                        value={vmname}
                        onChange={onChangeOfName}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>VM TYPE</label>
                      <Dropdown
                        placeholder="Select Machine Type"
                        //loading={loading}
                        selection
                        search
                        options={vmTypeOptions}
                        onChange={onChangeOfVMTypeId}
                        //value={vmTypeId}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>HARDWARE TYPE</label>
                      <Dropdown
                        placeholder="Select Hardware Type"
                        // loading={loading}
                        selection
                        search
                        options={hardware_types}
                        onChange={onChangeOfHardWareTypeId}
                        //value={hardware_type_id}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>CORPORATE </label>
            <Dropdown
              placeholder="Select Corporate Type"
              //loading={loading}
              selection
              search
             options={corporates}
              onChange={onChangeCorporates}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>WAREHOUSE </label>
                      <Dropdown
                        placeholder="Select Warehouse Type"
                        //loading={loading}
                        selection
                        search
                        options={warehouses}
                        onChange={onChangeOWarehouse}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>OPERATIONAL STATUS </label>
                      <Dropdown
                        placeholder="Select Status Type"
                        //loading={loading}
                        selection
                        search
                        options={oparationalstatusTypes}
                        onChange={onChangeOparetionalStatus}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>CONSUMER APP ENABLED</label>
                      <Dropdown
                        placeholder="Select Status"
                        selection
                        search
                        //  disabled={loading || vmTypeLoading}
                        options={statusOptions}
                        onChange={onChangeOfIsConsumerAppEnabled}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>HEALTH APP ENABLED</label>
                      <Dropdown
                        placeholder="Select Status"
                        selection
                        search
                        //  disabled={loading || vmTypeLoading}
                        options={statusOptions}
                        onChange={onChangeOfIsHealthAppEnabled}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>
                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>SHARE PERCENTAGE</label>
                      <input
                        type="number"
                        placeholder=""
                        value={sharePercentage}
                        onChange={onChangeOfSharePercentage}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Dropdown
                      label="ADD COHORTS"
                      fluid
                      multiple
                      selection
                      options={AddCohortsOptions}
                      onChange={onChangeOfAddCohorts}
                      /* value={added_cohort_id} */
                      placeholder="ADD COHORTS"
                      search
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />

                    <Form.Dropdown
                      label="REMOVE COHORTS"
                      placeholder="REMOVE COHORTS"
                      fluid
                      multiple
                      search
                      selection
                      options={RemoveCohortsOptions}
                      onChange={onChangeOfRemoveCohorts}
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />
                    <Form.Dropdown
                      label="ADD PAYMENTS"
                      fluid
                      multiple
                      search
                      selection
                      options={AddPaymentsOptions}
                      onChange={onChangeOfAddPayments}
                      placeholder="ADD PAYMENTS"
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />
                    <Form.Dropdown
                      label="REMOVE PAYMENTS"
                      placeholder="REMOVE PAYMENTS"
                      fluid
                      multiple
                      search
                      selection
                      options={RemovePaymentsOptions}
                      onChange={onChangeOfRemovePayments}
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />

                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>SERIAL NUMBER</label>
                      <input
                        placeholder="Enter Your Serial Number"
                        onChange={onChangeOfSerialNo}
                        value={vmSerialNo}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>

                    <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>CART LIMIT</label>
            <Dropdown
              placeholder="Select Cart Limit "
             // loading={loading}
              selection
              search
             options={cart_Limt}
            onChange={onChangeCartLimit} 
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>


                    <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>LOCATION TYPE</label>
            <Dropdown
              placeholder="Select Location Type"
             // loading={loading}
              selection
              search
             options={location_types}
            onChange={onChangeOfLocationTypeId} 
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

                    <Form.Dropdown
                      label="REMOVE SLOTS"
                      placeholder="REMOVE SLOTS"
                      fluid
                      multiple
                      search
                      selection
                      options={RemoveSlotsOption}
                      onChange={onChangeOfRemoveSlots}
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />
                    <Form.Dropdown
                      label="ADD SLOTS"
                      placeholder="ADD SLOTS"
                      fluid
                      multiple
                      onClick={handleAddSlotModle}
                      selection
                      style={{
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
                    />
                    {AddslotModel && (
                      <form
                        onSubmit={(e) => {
                          handleSubmit(e, inputFields);
                        }}
                      >
                        <div className="form-row">
                          {inputFields.map((inputField, index) => (
                            <Fragment key={`${inputField}~${index}`}>
                              <div className="form-group col-sm-6">
                                <label
                                  style={{
                                    "font-size": "18px",
                                    "font-weight": "700",
                                    color: "rgb(96 96 96 / 87%)",
                                  }}
                                >
                                  SLOT ID
                                </label>
                                <input
                                  type="number"
                                  className=""
                                  id="slot_id"
                                  name="slot_id"
                                  value={inputField.slot_id}
                                  onChange={(event) =>
                                    handleInputChange(index, event)
                                  }
                                  style={{
                                    "border-color": "white",
                                    "font-size": "20px",
                                    "background-color": "#f7f7f7",
                                    "margin-bottom": "3rem",
                                    "margin-top": "1rem",
                                  }}
                                />
                              </div>
                              <div className="form-group col-sm-4">
                                <label
                                  style={{
                                    "font-size": "18px",
                                    "font-weight": "700",
                                    color: "rgb(96 96 96 / 87%)",
                                  }}
                                >
                                  MV ID
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="mv_id"
                                  name="mv_id"
                                  value={inputField.mv_id}
                                  onChange={(event) =>
                                    handleInputChange(index, event)
                                  }
                                  style={{
                                    "border-color": "white",
                                    "font-size": "20px",
                                    "background-color": "#f7f7f7",
                                    "margin-bottom": "3rem",
                                    "margin-top": "1rem",
                                  }}
                                />
                              </div>
                              <div>
                                <div className="form-group col-sm-4">
                                  <label
                                    style={{
                                      "font-size": "18px",
                                      "font-weight": "700",
                                      color: "rgb(96 96 96 / 87%)",
                                    }}
                                  >
                                    CAPACITY
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="capacity"
                                    name="capacity"
                                    value={inputField.capacity}
                                    onChange={(event) =>
                                      handleInputChange(index, event)
                                    }
                                    style={{
                                      "border-color": "white",
                                      "font-size": "20px",
                                      "background-color": "#f7f7f7",
                                      "margin-bottom": "1rem",
                                      "margin-top": "1rem",
                                    }}
                                  />
                                </div>

                                <div style={{ "margin-top": "2rem" }}>
                                  <button
                                    className=""
                                    type="button"
                                    disabled={index === 0}
                                    onClick={() => handleRemoveFields(index)}
                                  >
                                    -
                                  </button>
                                  <button
                                    className=""
                                    type="button"
                                    onClick={() => handleAddFields()}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </Fragment>
                          ))}
                        </div>
                      </form>
                    )}
                    <Form.Field>
                      <label>UPLOAD IMAGE </label>

                      <input
                        type="file"
                        /* enctype="multipart/form-data" */
                        placeholder="Example: VMLogo/Paytm_logo.png"
                        onChange={UploadImgFun}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                      <button onClick={UploadImgBtn}>UPLOAD</button>
                    </Form.Field>
                    <Form.Field style={{ "margin-bottom": "3rem" }}>
                      <label>LOCATION</label>
                      <input
                        placeholder="Example: Paytm B121 Sector 5 (Max 50 character)"
                        value={vmStreet}
                        onChange={onChangeOfVMStreet}
                        style={{
                          "border-color": "white",
                          "font-size": "20px",
                          "background-color": "#f7f7f7",
                        }}
                      />
                    </Form.Field>
                    <div style={{ display: "flex", marginBottom: "3rem" }}>
                      <Form.Field style={{ width: "50%" }}>
                        <Form.Dropdown
                          required
                          placeholder="State"
                          search
                          selection
                          //disabled={loading || stateLoading}
                          options={stateList}
                          onChange={onChangeOfVMState}
                          style={{
                            "border-color": "white",
                            "font-size": "20px",
                            "background-color": "#f7f7f7",
                          }}
                        />
                      </Form.Field>

                      <Form.Field
                        required
                        style={{ width: "52%", "margin-left": "2px" }}
                      >
                                   <Dropdown
              placeholder="Select City"
              selection
              search
            disabled={cityLoading} 
              options={cityList}
              onChange={onChangeOfVMCity}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              
                
              }}
            />
                      </Form.Field>
        
         
                    </div>

                    <div style={{ display: "flex", marginBottom: "3rem" }}>
                      <Form.Field style={{ width: "52%" }}>
                        <input
                          placeholder="Latitude"
                          value={lat}
                          onChange={onChangeOfLat}
                          style={{
                            "border-color": "white",
                            "font-size": "20px",
                            "background-color": "#f7f7f7",
                          }}
                        />
                      </Form.Field>

                      <Form.Field
                        style={{ width: "54%", "margin-left": "2px" }}
                      >
                        <input
                          placeholder="Longitude"
                          value={lng}
                          onChange={onChangeOfLng}
                          style={{
                            "border-color": "white",
                            "font-size": "20px",
                            "background-color": "#f7f7f7",
                          }}
                        />
                      </Form.Field>
                    </div>
                  </Form>
                  <Button
                    color="blue"
                    onClick={(e) => {
                      handleUpdate(e, inputFields);
                    }}
                    style={{
                      width: "100%",
                      padding: "20px",
                      "font-size": "20px",
                    }}
                  >
                    UPDATE
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          width: "60%",
          "box-shadow": " 0 2px 14px 1px #504c4c",
          "margin-bottom": "14px",
        }}
      >
        <div style={{ "margin-bottom": "44px" }}>
          <table>
            <th>
              <div style={{ display: "flex" }}>
                <input
                  placeholder="Search by Id or Name"
                  style={{ padding: "10px", width: "100%" }}
                  onChange={(e) => {
                    Search(e.target.value);
                  }}
                />
              </div>
            </th>
            <th>
              <button
                style={{
                  "font-size": "14px",
                  padding: "14px",
                  color: "white",
                  "background-color": "green",
                  border: "none",
                  "border-radius": "10px",
                  width: "100%",
                }}
                onClick={handleCreateVm}
              >
                CREATE NEW VM
              </button>
            </th>
          </table>
        </div>

        <hr />

        <InfinitScroll
          dataLength={allMachine.length}
          next={fetchNextUsers}
          hasMore={morescroll}
          useWindow={false}
          scrollableTarget="scrollableDiv"
          loader={<h4> </h4>}
        >
          <div
            id="scrollableDiv"
            style={{ height: "690px", overflow: "auto", width: width }}
          >
            {console.log("this.state.items", allMachine)}

            <Fragment>
              <table style={{ width: "100%" }}>
                <tr>
                  <th>VM ID</th>
                  <th>VM NAME</th>
                  <th>STATUS</th>
                </tr>
                {vmlistData &&
                  vmlistData.length &&
                  vmlistData.map((el) => (
                    <Fragment>
                      {el.id > 0 && (
                        <Fragment>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={el.id}
                            value={el.id}
                            onClick={(e) => {
                              vmDetails(el.id);
                            }}
                          >
                            <td>{el.id}</td>

                            <td style={{ width: "50%" }}>{el.name}</td>

                            <td>{el.operational_status}</td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))}
              </table>
            </Fragment>
          </div>
        </InfinitScroll>
      </div>

      {saveVMDetailsData && (
        <div
          style={{
            background: "fffff",
            width: "45%",
            "margin-left": "2%",

            height: "59.7rem;",
            border: "2px solid beige",
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            height: "880px",
            marginBottom: "14px",
            "box-shadow": " 0 2px 14px 1px #504c4c",
            "margin-right": "16%",

            /*  "box-shadow": "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
             */
          }}
        >
          <div
            style={{
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
              padding: "10px",
            }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex" }}>
                <div>
                  <h3>STATUS:</h3>
                </div>
                <div>
                  <h3>{vmdt.operational_status}</h3>
                </div>
              </div>
            </div>
            <div style={{display:"flex",marginRight:"5%"}}>
            {!(vmdt.operational_status === "Inactive") && (
              <button
                onClick={openDecomissionmodel}
                style={{
                  padding: "6px 32px",
                  height: "40px",
                  cursor: "pointer",
                  color: "red",
                  "border-radius": "10px",
                  "border-color": "#ff0000a6",
                  "margin-right":"5%"
                }}
              >
                Decomission
              </button>
            )}

            <button
              onClick={openmodel}
              style={{
                padding: "6px 32px",
                height: "40px",

                cursor: "pointer",
                "background-color": "green",
                color: "white",
                "background-color": "green",
                border: "white",
                "border-radius": "10px",
              }}
            >
              EDIT
            </button>
            </div>
          </div>

          <hr />

          <div style={{ padding: "1%" }}>
            <div style={{ width: "100%", display: "flex" }}>
              {}
              {vmdt.address.image_path ? (
                <img
                  style={{ width: "20%", height: "130px", padding: "1%" }}
                  src={`${baseS3Url}` + `${vmdt.address.image_path}`}
                />
              ) : (
                <img
                  style={{ width: "20%", height: "130px", padding: "1%" }}
                  src={NoImg}
                />
              )}

              <div style={{ padding: "1%", width: "100%" }}>
                <div style={{ display: "flex", padding: "1%" }}>
                  <h3 style={{ color: "brown", "font-size": "16px" }}>
                    VM NAME:&nbsp;
                  </h3>
                  {vmdt.name && (
                    <h3
                      style={{
                        marginTop: "0px",
                        "font-size": "16px",
                        "margin-left": "2px",
                      }}
                    >
                      {vmdt.name}
                    </h3>
                  )}
                </div>
             <div>
                <div style={{ display: "flex", padding: "1%" }}>
                  <div /* style={{width:"100%"}} */>
                    <h3 style={{ color: "brown", "font-size": "16px" }}>
                      RCOM ID:&nbsp;
                    </h3>
                  </div>
                  <div /* style={{width:"100%"}} */>
                    {vmdt.keys.com_id && (
                      <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                        {vmdt.keys.com_id}
                      </h3>
                    )}
                  </div>

                  <h3
                    style={{
                      color: "brown",
                      "margin-top": "0rem",
                      "margin-left": "2%",
                      "font-size": "16px",
                    }}
                  >
                    DEVICE ID:&nbsp;
                  </h3>
                  {vmdt.keys.device_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {vmdt.keys.device_id}
                    </h3>
                  )}
                </div>

                <div style={{ display: "flex", padding: "1%" }}>
                  <h3 style={{ color: "brown", "font-size": "16px" }}>
                    BOARD ID:&nbsp;
                  </h3>
                  {vmdt.keys.board_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {vmdt.keys.board_id}
                    </h3>
                  )}

                  <h3
                    style={{
                      color: "brown",
                      "margin-top": "0rem",
                      "font-size": "16px",
                      "margin-left": "2%",
                    }}
                  >
                    BLU ID:&nbsp;
                  </h3>
                  {vmdt.keys.bluetooth_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {vmdt.keys.bluetooth_id}
                    </h3>
                  )}
                </div>

                <div>
            <div style={{display:"flex"}}>
            <h3 style={{ color: "brown", "font-size": "16px" }}>

                    Serial Number:&nbsp;
                  </h3>
                  {vmdt.keys.board_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {vmdt.keys.serial_number}
                    </h3>
                  )}

                  </div>
                  </div>
              </div>
            
            </div>
            </div>
       

          </div>

          <hr />
          {view1 && (
            <div>
              {" "}
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  STREET:&nbsp;
                </h3>
                {vmdt.address.street && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.address.street}{" "}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  CITY:&nbsp;
                </h3>
                {vmdt.address.city && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {" "}
                    {vmdt.address.city}{" "}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  STATE:&nbsp;
                </h3>
                {vmdt.address.state && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.address.state}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  LATITUDE:&nbsp;
                </h3>
                {vmdt.address.latitude && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.address.latitude}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  LONGITUDE:&nbsp;
                </h3>
                {vmdt.address.longitude && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.address.longitude}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  HARDWARE TYPE:&nbsp;
                </h3>
                {vmdt.hardware_type && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.hardware_type}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  VM TYPE:&nbsp;
                </h3>
                {vmdt.machine_type && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.machine_type}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  HEALTH ALERT:&nbsp;
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmdt.health_report_enabled ? (
                    <Fragment>True</Fragment>
                  ) : (
                    <Fragment>false</Fragment>
                  )}
                </h3>
              </div>
              <div style={{ display: "flex", width: "99%" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  CONSUMER APP:&nbsp;
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {vmdt.consumer_app_enabled ? (
                    <Fragment>True</Fragment>
                  ) : (
                    <Fragment>false</Fragment>
                  )}
                </h3>
              </div>
              <div style={{ display: "flex" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                  WAREHOUSE ID: &nbsp;
                </h3>
                {vmdt.warehouse && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.warehouse.id}
                  </h3>
                )}
              </div>
              <div style={{ display: "flex", width: "100%" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                  WAREHOUSE NAME: &nbsp;
                </h3>
                {vmdt.warehouse && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {vmdt.warehouse.name}
                  </h3>
                )}
              </div>
              {vmdt.corporate && (
                <Fragment>
                  <div style={{ display: "flex" }}>
                    <h3
                      style={{
                        color: "brown",
                        "font-size": "16px",
                        "margin-left": "2%",
                      }}
                    >
                      {" "}
                      CORPORATE ID: &nbsp;
                    </h3>
                    {vmdt.corporate && (
                      <h3
                        style={{
                          marginTop: "0px",
                          "font-size": "16px",
                          "margin-left": "2px",
                        }}
                      >
                        {vmdt.corporate.id}
                      </h3>
                    )}
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <h3
                      style={{
                        color: "brown",
                        "font-size": "16px",
                        "margin-left": "2%",
                      }}
                    >
                      {" "}
                      CORPORATE NAME: &nbsp;
                    </h3>
                    {vmdt.corporate && (
                      <h3
                        style={{
                          marginTop: "0px",
                          "font-size": "16px",
                          "margin-left": "2px",
                        }}
                      >
                        {vmdt.corporate.name}
                      </h3>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
          )}

          <div>
            <hr />
            <p
              onClick={handleView1}
              style={{
                "text-align": "center",
                color: "blue",
                cursor: "pointer",
              }}
            >
              {view1 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
            </p>
          </div>

          <div>
            <div>
              <hr />
              <p
                style={{ display: "flex", "justify-content": " space-around" }}
              >
                COHORTS{" "}
                <p
                  onClick={handleView2}
                  style={{
                    "text-align": "center",
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  {view2 ? (
                    <Fragment>HIDE</Fragment>
                  ) : (
                    <Fragment>VIEW</Fragment>
                  )}
                </p>
              </p>
            </div>
            <hr />

            {view2 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>ID</th>
                    <th>NAME</th>
                  </tr>

                  {vmdt.cohorts &&
                    vmdt.cohorts.length &&
                    vmdt.cohorts.map((el) => (
                      <Fragment>
                        {el.id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                            >
                              <td>{el.id}</td>

                              <td>{el.name}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}
          </div>

          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              SLOTS{" "}
              <p
                onClick={handleView3}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                  marginLeft: "7%",
                }}
              >
                {view3 ? (
                  <Fragment style={{ cursor: "pointet" }}>HIDE</Fragment>
                ) : (
                  <Fragment>VIEW</Fragment>
                )}
              </p>
            </p>
            <hr />

            {view3 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>ID</th>
                    <th>MV_ID</th>
                    <th>CAPACITY</th>
                  </tr>
                  {vmdt.slots &&
                    vmdt.slots.length &&
                    vmdt.slots.map((el) => (
                      <Fragment>
                        {el.slot_id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                              /*    onClick={(e) => {
                                OnClickVMSideDetailsPage(el.id);
                              }} */
                            >
                              <td>{el.slot_id}</td>

                              <td>{el.mv_id}</td>
                              <td>{el.capacity}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}
          </div>

          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              PAYMENTS
              <p
                onClick={handleView4}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                {view4 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
              </p>
            </p>
            <hr />
            {view4 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>PG-ID</th>
                    <th>NAME</th>
                  </tr>
                  {vmdt.payment_configs &&
                    vmdt.payment_configs.length &&
                    vmdt.payment_configs.map((el) => (
                      <Fragment>
                        {el.id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                              /*   onClick={(e) => {
                                OnClickVMSideDetailsPage(el.id);
                              }} */
                            >
                              <td>{el.id}</td>

                              <td>{el.name}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VendingMachines;



// WEBPACK FOOTER //
// ./src/Modules/VMs/component.jsx